import React from 'react'
import { Link } from 'react-router-dom'
import styles from '../../sass/signin.module.scss'
import { IMG } from '../../constant'

const SuccessPassword = () => {
  return (
    <div className={styles.AuthSectionContainer}>
      <div className={styles.AuthSectionContainer_body} style={{ backgroundImage: `url(${IMG.authblur})` }}>
        <img src={IMG.logo} className={styles.AuthSectionContainer_logo} alt='logo' />
        <h1 className={styles.AuthSectionContainer_title}>Reset Successful!</h1>
        <p className={styles.AuthSectionContainer_subtitle}>Your password has been updated. <br/>You can now log in with your new credentials.</p>

        <div className={styles.AuthSectionContainer_footer}>
          <Link to='/login' className={styles.AuthSectionContainer_link}>↩&nbsp;&nbsp;Back to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default SuccessPassword;
